import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.65, delay, ease: "easeOut" }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p
    className={`font-mono text-xs font-semibold uppercase tracking-[0.25em] ${
      light ? "text-terra-400" : "text-terra-500"
    }`}
  >
    {children}
  </p>
);
